import { createTestRemindersService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const TestRemindersService = createTestRemindersService(authorizedHttpClient, import.meta.env.VITE_API_URL)
